<template >
  <div class="supplier_login"
       :style="note">
    <!-- <van-nav-bar title="商城"
                 class="title">
      <van-icon name="cross"
                slot="left" />>
      <van-icon name="ellipsis"
                slot="right" />
    </van-nav-bar> -->
    <van-form @submit="onSubmit"
              class="form">
      <van-image round
                 cover
                 class="image"
                 :src="headImg" />
      <van-field name="手机号码"
                 v-model="form.username"
                 type="tel"
                 maxlength="11"
                 :formatter="formatter"
                 placeholder="手机号码"
                 :rules="[{ required: true, message: '请输入手机号码' },  { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}]"
                 :left-icon="phone" />
      <van-field name="验证码"
                 v-model="form.code"
                 placeholder="验证码"
                 maxlength="6"
                 :left-icon="key"
                 :rules="[{ required: true, message: '请输入验证码' }]">
        <template #button>
          <van-button size="small"
                      class="sendCode"
                      @click="getcode"
                      :disabled="disabled"
                      type="default">{{time}}</van-button>
        </template>
      </van-field>
      <div class="checked">
        <van-checkbox v-model="checked"
                      shape="square"
                      icon-size="13px"><a href="javascript:;" @click.stop="toPageAgent">我已阅读《用户服务协议》</a></van-checkbox>
      </div>
      <div class="login">
        <van-button block
                    round
                    color="#E2174B"
                    native-type="submit">
          <span style="color: #ffffff;margin-right:20px;">登录</span>
          <img :src="right"
               class="img">
        </van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import { getNOteCode, wxlogin } from '@/api/login/index.js'
import { getUrlParam } from '@/utils/utils.js'
export default {

  name: 'clientLogin',
  data () {
    return {
      phone: require('@/assets/phone1.png'),
      key: require('@/assets/code.png'),
      right: require('@/assets/right1.png'),
      checked: true,
      time: '发验证码',
      close: '',
      disabled: false,
      headImg :"",
      form: {
        username: '',
        password: '',
        headImg : '',
        nickName : '',
        openId : '',
        pid : undefined
      },
      note: {
        backgroundImage: "url(" + require("@/assets/bgc.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      },
    }
  },
  created () {
    let headImg = localStorage.getItem("headImg")
    if (headImg){
      this.headImg = localStorage.getItem("headImg")
    }
    // if (this.getUrlKey("openid") != null) {
    //   this.headImg = this.getUrlKey("headImg")
    //   localStorage.setItem("openid", this.getUrlKey("openid"))
    //   localStorage.setItem("headImg",this.getUrlKey("headImg"))
    //   localStorage.setItem("nickname",this.getUrlKey("nickname"))
    //   //this.form.headImg = this.getUrlKey("headImg")
    //   //this.form.nickName = this.getUrlKey("nickname")
    // } else {
    //   if (localStorage.getItem('openid') == null) {

    //   }
    // }
  },
  methods: {
    formatter(value) {
      return value.replace(/[^\d]/g,'');
    },
    getcode () {
      const params = {
        phone: this.form.username
      }
      this.disabled = true
      getNOteCode(params).then((res) => {
        console.log(res.success)
        if (res.success) {
          this.time = 60
          this.close = setInterval(this.gettime, 1000)
        } else {
          this.disabled = false
        }
      })
    },
    getUrlKey(name){
　　   return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(decodeURI(window.location.href)) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    gettime () {
      if (this.time == 0) {
        // 清除js定时器
        clearInterval(this.close)
        this.time = '发验证码'
        this.disabled = false
      } else {
        this.time--
      }
    },
    onSubmit () {
      if(!this.checked){
        this.$toast.fail("请先勾选服务协议")
        return;
      }
      if (localStorage.getItem('openid') != null) {
        this.form.openId = localStorage.getItem('openid')
      }
      // if (localStorage.getItem('pid') != null) {
      //   this.form.pid = localStorage.getItem('pid')
      // }
      this.$store.dispatch('Login', this.form).then((res) => {
        console.log(res);
        if (res.code == '200') {
           if (this.$route.query.pid != undefined && this.$route.query.pid != null) {
              this.$router.push({
                 path: 'product/detail',
                 query: { id: this.$route.query.pid}
               })
           } else {
              if (this.getUrlKey('openid') == null) {
                 this.$router.go(-1)
              } else {
                 window.location.replace("/");
              }
           }
        }
      })
    },
    weChartLogin () {
      wxlogin().then((res) => {
        window.open(res.path)
      })
    },
    toPageAgent() {
      this.$router.push('/agreement')
    },
    clickRight () {
      this.$router.push('/register')
    }
  }
}
</script>

<style lang="less" scoped>
.supplier_login {
  height: 100vh;
  overflow: hidden;
  .title {
    background-color: #ededed;
    .van-icon {
      font-size: 20px;
      color: #333;
    }
  }
  .form {
    position: relative;
    box-sizing: border-box;
    width: 314px;
    height: 260px;
    margin: 105px auto 0;
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    border-radius: 14px;
    padding: 70px 15px 0;
    .sendCode {
      border: 1px solid #ff8ba6;
      color: #ff8ba6;
    }
    .van-field {
      margin-bottom: 10px;
      font-size: 16px;
      color: #999;
    }
  }
  .image {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 80px;
    z-index: 999;
  }
  .checked {
    margin-left: 10px;
    margin-top: 20px;
    a {
      font-size: 14px;
      color: #898da4;
    }
  }
  .btn_login {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    .btn {
      position: relative;
      width: 150px;
      height: 42px;
      background-color: #fe003b;
      border-radius: 21px;

      font-size: 20px;
      color: #fff;
      .text {
        position: absolute;
        top: 6px;
        left: 33px;
        font-size: 20px;
      }
      .img {
        position: absolute;
        right: 33px;
        top: 11px;
        width: 20px;
        height: 20px;
      }
    }
  }
  /deep/.van-field__left-icon {
    margin-right: 10px;
  }
  .login {
    margin: 100px auto 0;
    width: 154px;
    height: 52px;
    .img {
      position: absolute;
      right: 33px;
      top: 11px;
      width: 20px;
      height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/clientLogin.vue